{
  "Common": {
    "close": "Đóng",
    "closeAlert": "Đóng cảnh báo",
    "notifications": "Thông báo",
    "newNotification": "Mới",
    "readStatus": "Đã đọc",
    "openLink": "Mở liên kết",
    "theme": "Chủ đề",
    "lightTheme": "Giao diện sáng",
    "darkTheme": "Giao diện tối",
    "systemTheme": "Theo hệ thống",
    "density": "Mật độ",
    "compact": "Gọn",
    "normal": "Thường",
    "comfortable": "Thoải mái",
    "columns": "Cột",
    "loading": "Đang tải",
    "noData": "Không có dữ liệu",
    "clearFilter": "Xóa bộ lọc",
    "selectAll": "Chọn tất cả",
    "default": "Mặc định",
    "other": "Khác",
    "headerAlign": "Căn chỉnh tiêu đề",
    "alignLeft": "Căn trái",
    "alignCenter": "Căn giữa",
    "alignRight": "Căn phải"
  },
  "ValidationInput": {
    "required": "Trường này là bắt buộc.",
    "typeMismatch": "Định dạng không hợp lệ.",
    "pattern": "Sai mẫu",
    "tooShort": "Quá ngắn",
    "tooLong": "Quá dài",
    "rangeUnderflow": "Giá trị nhỏ hơn mức tối thiểu.",
    "rangeOverflow": "Giá trị vượt quá mức tối đa.",
    "stepMismatch": "Sai bước",
    "badInput": "Giá trị không hợp lệ",
    "invalid": "Giá trị không hợp lệ"
  },
  "Loading": {
    "loadingPage": "Đang tải trang",
    "pleaseWait": "Vui lòng chờ"
  },
  "DatePicker": {
    "placeholder": "Chọn ngày",
    "today": "Hôm nay",
    "clear": "Xóa"
  },
  "DateTimePicker": {
    "time": "Thời gian",
    "clear": "Xóa",
    "done": "Xong"
  },
  "CalendarTimeline": {
    "today": "Hôm nay",
    "prev": "Trước",
    "next": "Sau",
    "month": "Tháng",
    "week": "Tuần",
    "day": "Ngày",
    "sprint": "Sprint",
    "newEvent": "Thêm sự kiện",
    "createEventTitle": "Tạo sự kiện",
    "create": "Tạo",
    "cancel": "Hủy",
    "resource": "Tài nguyên",
    "start": "Bắt đầu",
    "end": "Kết thúc",
    "resourcesHeader": "Tài nguyên",
    "expandGroup": "Mở rộng nhóm",
    "collapseGroup": "Thu gọn nhóm",
    "more": "+{n} thêm",
    "sprints": "{n} sprint",
    "deleteConfirm": "Xóa?"
  },
  "Pagination": {
    "navigationLabel": "Điều hướng phân trang",
    "showingResults": "Hiển thị {startItem}–{endItem} trong tổng {totalItems}",
    "firstPage": "Trang đầu",
    "previousPage": "Trang trước",
    "previous": "Trước",
    "nextPage": "Trang sau",
    "next": "Sau",
    "lastPage": "Trang cuối",
    "pageNumber": "Trang {page}",
    "itemsPerPage": "Số mục/trang",
    "search": "Tìm kiếm",
    "noOptions": "Không có lựa chọn"
  },
  "OCR": {
    "imageUpload": {
      "dragDropText": "Kéo & thả ảnh vào đây",
      "browseFiles": "Chọn tệp",
      "supportedFormats": "Hỗ trợ các định dạng ảnh"
    }
  },
  "FileUpload": {
    "dragDropText": "Kéo & thả tệp vào đây",
    "browseFiles": "Chọn tệp",
    "uploadFiles": "Tải tệp lên",
    "supportedFormats": "Hỗ trợ mọi định dạng tệp",
    "uploadedFiles": "Tệp đã tải lên",
    "clearAll": "Xóa tất cả",
    "fileTooLarge": "vượt quá giới hạn kích thước",
    "maxFilesReached": "Đã đạt giới hạn số tệp.",
    "uploadSuccess": "Đã tải lên thành công.",
    "uploadFailed": "Tải lên thất bại."
  },
  "UEditor": {
    "placeholder": "Nhập '/' để mở lệnh, hoặc bắt đầu viết...",
    "loading": "Đang tải trình soạn thảo...",
    "words": "từ",
    "characters": "ký tự",
    "colors": {
      "default": "Mặc định",
      "muted": "Mờ",
      "primary": "Chính",
      "secondary": "Phụ",
      "success": "Thành công",
      "warning": "Cảnh báo",
      "destructive": "Nguy hiểm",
      "info": "Thông tin",
      "accent": "Nhấn",
      "textColor": "Màu chữ",
      "highlight": "Nổi bật",
      "automatic": "Tự động",
      "moreColors": "Thêm màu...",
      "color": "Màu",
      "done": "Xong"
    },
    "toolbar": {
      "bold": "In đậm",
      "boldShortcut": "In đậm (Ctrl+B)",
      "italic": "In nghiêng",
      "italicShortcut": "In nghiêng (Ctrl+I)",
      "underline": "Gạch chân",
      "underlineShortcut": "Gạch chân (Ctrl+U)",
      "strike": "Gạch ngang",
      "code": "Code nội dòng",
      "subscript": "Chỉ số dưới",
      "superscript": "Chỉ số trên",
      "link": "Liên kết",
      "removeLink": "Gỡ liên kết",
      "image": "Chèn ảnh",
      "table": "Chèn bảng",
      "alignment": "Căn chỉnh",
      "alignLeft": "Căn trái",
      "alignCenter": "Căn giữa",
      "alignRight": "Căn phải",
      "justify": "Căn đều",
      "bulletList": "Danh sách dấu chấm",
      "orderedList": "Danh sách số",
      "taskList": "Danh sách công việc",
      "quote": "Trích dẫn",
      "codeBlock": "Khối mã",
      "undo": "Hoàn tác (Ctrl+Z)",
      "redo": "Làm lại (Ctrl+Y)",
      "textStyle": "Kiểu chữ",
      "fontFamily": "Phông chữ",
      "fontSize": "Cỡ chữ",
      "lineHeight": "Giãn dòng",
      "fontDefault": "Phông mặc định",
      "sizeDefault": "Cỡ mặc định",
      "lineHeightDefault": "Giãn dòng mặc định",
      "letterSpacing": "Giãn chữ",
      "letterSpacingDefault": "Giãn chữ mặc định",
      "fontSans": "Sans",
      "fontSerif": "Serif",
      "fontMono": "Mono",
      "normal": "Văn bản thường",
      "heading1": "Tiêu đề 1",
      "heading2": "Tiêu đề 2",
      "heading3": "Tiêu đề 3",
      "emoji": "Chèn Emoji",
      "imageLayoutBlock": "Ảnh Dạng Khối",
      "imageLayoutLeft": "Ảnh Trái, Chữ Phải",
      "imageLayoutRight": "Ảnh Phải, Chữ Trái",
      "imageWidthSm": "Ảnh Nhỏ",
      "imageWidthMd": "Ảnh Vừa",
      "imageWidthLg": "Ảnh Lớn",
      "imageResetSize": "Đặt Lại Kích Thước Ảnh",
      "imageDelete": "Xóa Ảnh"
    },
    "slashCommand": {
      "basicBlocks": "Khối cơ bản",
      "text": "Văn bản",
      "textDesc": "Khối văn bản thuần",
      "heading1": "Tiêu đề 1",
      "heading1Desc": "Tiêu đề phần lớn",
      "heading2": "Tiêu đề 2",
      "heading2Desc": "Tiêu đề phần vừa",
      "heading3": "Tiêu đề 3",
      "heading3Desc": "Tiêu đề phần nhỏ",
      "bulletList": "Danh sách dấu chấm",
      "bulletListDesc": "Danh sách liệt kê đơn giản",
      "orderedList": "Danh sách số",
      "orderedListDesc": "Danh sách có thứ tự",
      "todoList": "Danh sách công việc",
      "todoListDesc": "Checkbox công việc",
      "quote": "Trích dẫn",
      "quoteDesc": "Tạo trích dẫn",
      "codeBlock": "Khối mã",
      "codeBlockDesc": "Mã với tô màu cú pháp",
      "divider": "Phân cách",
      "dividerDesc": "Đường kẻ ngang",
      "table": "Bảng",
      "tableDesc": "Thêm bảng",
      "noResults": "Không tìm thấy khối phù hợp",
      "callout": "Hộp thông tin",
      "calloutDesc": "Làm nổi bật thông tin chính bằng hộp chú thích",
      "bookmark": "Thẻ liên kết",
      "bookmarkDesc": "Nhúng một liên kết dưới dạng thẻ xem trước",
      "fileCard": "Tệp đính kèm",
      "fileCardDesc": "Tải lên tệp tin đính kèm",
      "formCheckbox": "Checkbox biểu mẫu",
      "formCheckboxDesc": "Thêm ô checkbox biểu mẫu",
      "formRadio": "Radio biểu mẫu",
      "formRadioDesc": "Thêm nút chọn một (Radio) biểu mẫu"
    },
    "floatingMenu": {
      "addBlock": "Thêm khối"
    },
    "linkInput": {
      "placeholder": "Dán hoặc nhập liên kết..."
    },
    "imageInput": {
      "urlTab": "URL",
      "uploadTab": "Tải lên",
      "urlLabel": "URL hình ảnh",
      "urlPlaceholder": "https://example.com/image.jpg",
      "uploadLabel": "Chọn hình ảnh",
      "uploadPlaceholder": "Nhấn để tải ảnh lên",
      "uploading": "Đang tải lên...",
      "uploadError": "Tải lên thất bại. Vui lòng thử lại.",
      "altLabel": "Mô tả ảnh (tuỳ chọn)",
      "altPlaceholder": "Mô tả hình ảnh...",
      "addBtn": "Thêm ảnh",
      "cancelBtn": "Hủy",
      "addFromUrl": "Thêm từ URL"
    },
    "emojiPicker": {
      "searchPlaceholder": "Tìm kiếm biểu tượng cảm xúc",
      "noResults": "Không tìm thấy emoji",
      "tryDifferentSearch": "Thử từ khóa khác"
    },
    "stickerPicker": {
      "searchPlaceholder": "Tìm kiếm nhãn dán",
      "noResults": "Không tìm thấy nhãn dán nào",
      "tryDifferentSearch": "Thử từ khóa khác"
    },
    "emojiSuggestion": {
      "title": "Emoji",
      "noResults": "Không tìm thấy emoji",
      "showingCount": "Hiển thị {shown} trong tổng số {total} emoji"
    },
    "formulaSuggestion": {
      "title": "Hàm",
      "noResults": "Không tìm thấy hàm",
      "sum": "Cộng các giá trị trong vùng",
      "avg": "Tính trung bình các giá trị trong vùng",
      "min": "Giá trị nhỏ nhất trong vùng",
      "max": "Giá trị lớn nhất trong vùng",
      "count": "Đếm các ô dạng số trong vùng"
    },
    "tableMenu": {
      "insert3x3": "Chèn bảng 3×3",
      "insertTable": "Chèn bảng",
      "gridPreview": "Chèn bảng {rows}×{cols}",
      "addColumnBefore": "Thêm cột trước",
      "addColumnAfter": "Thêm cột sau",
      "addRowBefore": "Thêm hàng trước",
      "addRowAfter": "Thêm hàng sau",
      "duplicateColumn": "Nhân đôi cột",
      "duplicateRow": "Nhân đôi hàng",
      "clearColumnContents": "Xóa nội dung cột",
      "clearRowContents": "Xóa nội dung hàng",
      "deleteColumn": "Xóa cột",
      "deleteRow": "Xóa hàng",
      "deleteTable": "Xóa bảng",
      "toggleHeaderRow": "Bật/tắt hàng tiêu đề",
      "toggleHeaderColumn": "Bật/tắt cột tiêu đề",
      "mergeCells": "Gộp ô",
      "splitCell": "Tách ô",
      "openControls": "Mở điều khiển bảng",
      "quickAddColumnAfter": "Thêm nhanh cột sau",
      "quickAddRowAfter": "Thêm nhanh hàng sau",
      "expandTable": "Mở rộng bảng",
      "dragRow": "Kéo hàng",
      "dragColumn": "Kéo cột",
      "alignLeft": "Căn bảng trái",
      "alignCenter": "Căn bảng giữa",
      "alignRight": "Căn bảng phải",
      "cellBackground": "Màu nền ô",
      "cellBorder": "Viền ô",
      "borderStyle": "Kiểu viền",
      "borderWidth": "Độ dày viền",
      "borderColor": "Màu viền",
      "clearBorder": "Xóa viền",
      "formula": "Công thức",
      "numberFormat": "Định dạng số",
      "formatText": "Chữ",
      "formatDate": "Ngày",
      "apply": "Áp dụng",
      "clear": "Xóa",
      "recalculate": "Tính lại",
      "done": "Xong",
      "alignVertical": "Căn lề dọc",
      "alignVerticalTop": "Căn trên",
      "alignVerticalMiddle": "Căn giữa",
      "alignVerticalBottom": "Căn dưới"
    },
    "callout": {
      "selectEmoji": "Chọn Biểu tượng",
      "backgroundColor": "Màu nền"
    },
    "radio": {
      "groupName": "Tên nhóm",
      "editGroup": "Sửa tên nhóm"
    },
    "bookmark": {
      "clickToOpenNewTab": "Bấm để mở liên kết này trong tab mới.",
      "clickToOpenLink": "Bấm để mở liên kết.",
      "noDescription": "Không có mô tả.",
      "failedToLoad": "Tải bản xem trước thất bại. Bấm để mở liên kết.",
      "previewFailed": "Không tải được bản xem trước",
      "retryPreview": "Thử lại"
    },
    "fileCard": {
      "unnamed": "Tệp không tên",
      "uploading": "(Đang tải lên...)",
      "uploadFailed": "Tải lên thất bại",
      "retryUpload": "Tải lại"
    },
    "menubar": {
      "file": "Tập tin",
      "edit": "Sửa",
      "view": "Xem",
      "insert": "Thêm",
      "format": "Định dạng",
      "tools": "Công cụ",
      "table": "Bảng",
      "save": "Lưu",
      "exportHtml": "Xuất HTML",
      "undo": "Hoàn tác",
      "undoShortcut": "Ctrl+Z",
      "redo": "Làm lại",
      "redoShortcut": "Ctrl+Y",
      "cut": "Cắt",
      "cutShortcut": "Ctrl+X",
      "copy": "Chép",
      "copyShortcut": "Ctrl+C",
      "paste": "Dán",
      "pasteShortcut": "Ctrl+V",
      "pasteAsText": "Dán như văn bản",
      "selectAll": "Chọn tất cả",
      "selectAllShortcut": "Ctrl+A",
      "sourceCode": "Mã nguồn",
      "preview": "Xem trước",
      "fullscreen": "Đầy màn hình",
      "fullscreenShortcut": "Ctrl+Shift+F",
      "image": "Hình ảnh",
      "link": "Liên kết",
      "linkShortcut": "Ctrl+K",
      "insertTable": "Bảng",
      "horizontalRule": "Đường kẻ ngang",
      "bold": "Tô đậm",
      "boldShortcut": "Ctrl+B",
      "italic": "In nghiêng",
      "italicShortcut": "Ctrl+I",
      "underline": "Gạch dưới",
      "underlineShortcut": "Ctrl+U",
      "strike": "Gạch ngang",
      "superscript": "Trên dòng",
      "subscript": "Dưới dòng",
      "code": "Mã",
      "wrap": "Ngắt dòng",
      "align": "Căn chỉnh",
      "clearFormatting": "Xoá định dạng",
      "paragraph": "Đoạn văn",
      "heading1": "Tiêu đề 1",
      "heading2": "Tiêu đề 2",
      "heading3": "Tiêu đề 3",
      "blockquote": "Trích dẫn",
      "codeBlock": "Khối mã",
      "taskList": "Danh sách việc",
      "alignLeft": "Trái",
      "alignCenter": "Giữa",
      "alignRight": "Phải",
      "alignJustify": "Đều",
      "tableProperties": "Thuộc tính bảng",
      "deleteTable": "Xoá bảng",
      "row": "Dòng",
      "column": "Cột",
      "cell": "Ô",
      "addRowBefore": "Thêm hàng phía trên",
      "addRowAfter": "Thêm hàng phía dưới",
      "deleteRow": "Xoá hàng",
      "addColumnBefore": "Thêm cột bên trái",
      "addColumnAfter": "Thêm cột bên phải",
      "deleteColumn": "Xoá cột",
      "mergeCells": "Gộp ô",
      "splitCell": "Tách ô",
      "imageUpload": "Tải ảnh lên",
      "formFields": "Trường biểu mẫu",
      "formCheckbox": "Checkbox biểu mẫu",
      "formRadio": "Nút chọn một (Radio)",
      "applySource": "Áp dụng",
      "closeDialog": "Đóng",
      "copyHtml": "Sao chép HTML",
      "exportDefault": "Xuất HTML",
      "previewEmpty": "Không có nội dung để xem trước.",
      "sourceCodeHint": "Chỉnh sửa HTML trực tiếp và nhấn Áp dụng để cập nhật nội dung."
    }
  }
}
